export const getImgixURL = (image: string): string => {
  return image
    ? image
        .replace("https://cdn.newonce.me/", "")
        .replace("https://black-steel.app.elpassion.com/", "")
    : "";
};

export const placeholder = "frontend-assets/placeholder.png";
